export enum Page {
  LOG_IN = '/log-in',
  CREATE_INSPECTION = '/create-inspection',
  PHOTO_CAPTURE = '/photo-capture',
  VEHICLE_TYPE_SELECTION = '/vehicle-type-selection',
}
